import DPO from 'dpo8core';

class SplitActionChain extends DPO.bll.ActionChain {
  execute(fields, action, params, source) {
    const me = this;
    const next = me.nextChain;

    switch (action) {
      case 'rotateLeftByStep':
      case 'rotateRightByStep':
        return next.performAction(fields, 'rotateSelectedFields', {
          deg: action.indexOf('Left') === -1 ? -5 : 5,
        });
      case 'translateLeft':
      case 'translateRight':
      case 'translateUp':
      case 'translateDown':
      case 'translateLeftSmall':
      case 'translateRightSmall':
      case 'translateUpSmall':
      case 'translateDownSmall': {
        let dx = 0;
        let dy = 0;

        if (action.indexOf('Up') !== -1) dy = -100;
        if (action.indexOf('Down') !== -1) dy = 100;
        if (action.indexOf('Left') !== -1) dx = -100;
        if (action.indexOf('Right') !== -1) dx = 100;
        if (action.indexOf('Small') !== -1) {
          dx /= 10;
          dy /= 10;
        }

        return next.performAction(fields, 'fieldTranslate', { dx, dy });
      }
      default:
        return false;
    }
  }
}

export default SplitActionChain;
